import { useEffect } from 'react'

import { useTranslation } from '@flecto/translations'

import { useDocumentState } from './useDocumentState'

export const useDocumentTranslation = () => {
  const { customerLanguage, setTranslationFunction } = useDocumentState()

  const { t } = useTranslation('saas', {
    keyPrefix: 'booking_documents',
    lng: customerLanguage,
  })

  useEffect(() => {
    setTranslationFunction(t)
  }, [t, setTranslationFunction, customerLanguage])

  return { t }
}
